import { DesktopDatePicker, PickersDay } from '@mui/x-date-pickers';
import React, { useRef, useState } from 'react';
import { getOnlyData } from '../../utils';
import dayjs from 'dayjs';
import { useAppSelector } from '../../store';
import { useTranslation } from 'react-i18next';
import CustomDatePicker from '../forms/theme-elements/CustomDatePicker';

export default function CusDatePicker({
  value,
  time,
  onChange,
  label,
  errorText = '',
  clearable,
  disabled
}) {
  const { t } = useTranslation();
  const defaultInputSize = useAppSelector((state) => state.customizer.inputSize);
  const [open, setOpen] = useState(false);
  const lastFocusedRef = useRef(null);

  return (
    <CustomDatePicker
      label={t(label)}
      disabled={disabled}
      format="DD.MM.YYYY"
      value={value ? dayjs(value) : null}
      onChange={(newValue) => {
        onChange(newValue ? getOnlyData(newValue, time) : null);
        setOpen(false);
      }}
      open={open}
      onOpen={() => setOpen(true)}
      // CRUTCH - не смог отключить возврат к инпуту при закрытии календаря
      onClose={() => {
        lastFocusedRef.current = document.activeElement;
        setOpen(false);
        setTimeout(() => {
          lastFocusedRef.current.focus();
        }, 50);
      }}
      closeOnSelect={true}
      autoFocus={false}
      slots={{
        day: (props) => <PickersDay {...props} autoFocus={false} />
      }}
      slotProps={{
        textField: {
          onClick: value ? undefined : () => setOpen(true),
          size: defaultInputSize,
          label: t(label),
          fullWidth: true,
          error: !!errorText,
          helperText: errorText,
          clearable: clearable,
          InputLabelProps: { shrink: true },
          placeholder: '',
          sx: {
            '& input': { paddingRight: '0' },
            '& .MuiOutlinedInput-root.Mui-disabled': {
              '& fieldset': {
                borderColor: (theme) => theme.palette.grey[200]
              },
              '&:hover fieldset': {
                borderColor: (theme) => theme.palette.grey[200]
              }
            }
          }
        }
      }}
    />
  );
}
